
import Vue from "vue";
import { getModel, Model } from "@/utils/models/model";
import AppHighlightEditConditions from "./HighlightEditConditions.vue";
import AppHighlightEditStyle from "./HighlightEditStyle.vue";
import { Browse } from "@/models/browse";
import { Highlight } from "@/utils/sale-edit/sale-edit-highlight";
import { BrowseService } from "@/services";

export default Vue.extend({
	data(){
		return {
			highlight: new Highlight(),
			currentTab: 0
		};
	},
	props: {
		value: {
			type: Object as ()=>Highlight,
			required: true
		},

	},
	computed: {
		tabs():string[]{
			return ["style", "conditions"].map(s=>this.$ct(s).toString());
		},
		model():Model {
			return getModel("SaleRow");
		},
		browse():Browse{
			let b = BrowseService.getBrowseWithoutViewSettings(7);
			if (!b) throw new Error("No such browse " + 7);
			return b;
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.highlight = new Highlight(this.value.getJSON());
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			this.$emit("input", new Highlight(this.highlight.getJSON()));
			this.close();
		},

	},
	components: {
		AppHighlightEditConditions,
		AppHighlightEditStyle
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
